import { useState } from 'react';
import { Form, Input, Button } from 'antd';

const LoginForm = ({ title, handleClick }) => {
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');

  const onFinish = (values) => {
    handleClick(values.email, values.password);
  };

  return (
    <div className='text-start'>
      <Form
        name="login"
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ remember: true }}
      >
        <Form.Item
          label="Email"
          name="email"
          rules={[{ required: true, message: '' }]}
        >
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            size="large"
          />
        </Form.Item>

        <Form.Item
          label="Parol"
          name="password"
          rules={[{ required: true, message: '' }]}
        >
          <Input.Password
            value={pass}
            onChange={(e) => setPass(e.target.value)}
            size="large"
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" size="large" danger htmlType="submit">
            {title}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export { LoginForm };
